<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card">
        <Toolbar class="p-mb-4 page-toolbar">
          <template #start>
            <div style="font-size: 1.4em; color: inherit" class="p-mr-3">{{ $t('Emails') }}</div>
            <template v-if="!emailsListIsEmpty">
              <AddNewButton :label="$t('newMessageLabel')"
                            @click="createMessage"
                            class="p-mr-2"/>
              <MultipleDeleteButton :label="`${$t('Delete')} ${selectedItems?.length ? `(${selectedItems?.length})` : ''}`"
                                    v-show="$store.getters.isAccountantOrHigher"
                                    @click="confirmItemsMultipleDelete"
                                    :disabled="!selectedItems?.length"
                                    class="p-mr-3"/>
              <ul class="radiobuttons-wrapper">
                <li class="p-field-radiobutton">
                  <RadioButton class="radio_button" id="radio_button_all" name="messagesState" value="1" v-model="messagesState" />
                  <label class="radio_button_label" for="radio_button_all">{{ $t('allMessagesLabel') }}</label>
                </li>
                <li class="p-field-radiobutton">
                  <RadioButton class="radio_button" id="radio_button_new" name="messagesState" value="2" v-model="messagesState" />
                  <label class="radio_button_label" for="radio_button_new">{{ $t('onlyNewMessagesLabel') }}</label>
                </li>
                <li class="p-field-radiobutton" v-show="$store.getters.isAccountantOrHigher">
                  <RadioButton class="radio_button" id="radio_button_answered" name="messagesState" value="3" v-model="messagesState" />
                  <label class="radio_button_label" for="radio_button_answered">{{ $t('answeredMessagesLabel') }}</label>
                </li>
                <li class="p-field-radiobutton" v-show="$store.getters.isAccountantOrHigher">
                  <RadioButton class="radio_button" id="radio_button_viewed" name="messagesState" value="4" v-model="messagesState" />
                  <label class="radio_button_label" for="radio_button_viewed">{{ $t('onlyViewedMessagesLabel') }}</label>
                </li>
              </ul>
            </template>
          </template>
          <template #end v-if="!emailsListIsEmpty">
            <SearchInput ref="searchInput" :disabled="dataTableIsLoading || messageIsOpened" v-model="searchData" @show-spinner="isLoading = true"/>
          </template>
        </Toolbar>

        <div class="p-d-flex" :class="{'p-flex-wrap': $store.state.mobileLayout || $store.state.tabletLayout}">
          <div v-if="!emailsListIsEmpty" style="width: 320px; min-width: 240px" :class="{'p-mr-3': !$store.state.mobileLayout && !$store.state.tabletLayout}">
            <OwnTree @node-select="changeEmailAccount"
                     :value="emailsList"
                     style="overflow: hidden;"
                     :expandedKeys="expandedKeys"
                     selectionMode="single"
                     v-model:selectionKeys="selectedFolder"/>
          </div>
          <div :style="{width: $store.state.mobileLayout || $store.state.tabletLayout || emailsListIsEmpty ? '100%' : '85%'}" :class="{'p-mt-5' : $store.state.mobileLayout || $store.state.tabletLayout}">
            <!--          <div>-->
            <Spinner v-if="isLoading && !messageIsOpened"/>
            <template v-if="!isLoading && !messageIsOpened">
              <DesktopDataTable v-if="!$store.state.mobileLayout && !$store.state.tabletLayout"
                                :dataTableIsLoading="dataTableIsLoading"
                                tableClass="messages-table"
                                :showHeader="false"
                                :tableName="$t('Emails')"
                                :itemsArrayIsEmpty="itemsArrayIsEmpty"
                                :showButtons="false"
                                :showSearchInput="false"
                                :headers="[
                                  {name: '', title: '', sortable: false},
                                  {name: 'sender_name', title: $t('Sender'), sortable: false},
                                  {name: 'is_read', sortable: false},
                                  {name: 'Subject', title: $t('Subject'), minWidth: '300px', sortable: false},
                                  {name: 'icons', sortable: false},
                                  {name: 'created_at', title: $t('Created'), sortable: false}
                                ]">
                <template v-slot:multiselectHeader>
                  <th v-show="$store.getters.isAccountantOrHigher" class="multiSelect-column-header">
                    <Checkbox :disabled="dataTableIsLoading || billingDataEditingLocked"
                              :class="{ 'billing-selection-checkbox-disabled': billingDataEditingLocked }"
                              @click="selectAllCheckboxOnClick"
                              :value="0"
                              v-model="selectAllCheckbox"/>
                    <!--                  <Checkbox @click="selectAllCheckboxOnClick" :value="0" v-model="selectAllCheckbox"/>-->
                  </th>
                </template>
                <template v-slot:body>
                  <tr v-for="(item, index) of items"
                      :key="index"
                      class="messages-row"
                      :class="[{'p-highlight': isItemSelected(item.id)}, {'bold-text' : !item.is_seen}]">
                    <td v-show="$store.getters.isAccountantOrHigher"
                        :class="{
                          'new-item': isItemAdded(item.id),
                          'billing-selection-cell-disabled': billingDataEditingLocked
                        }">
                      <Checkbox @click.stop
                                v-if="!isItemAdded(item.id)"
                                :disabled="dataTableIsLoading || billingDataEditingLocked"
                                :class="{ 'billing-selection-checkbox-disabled': billingDataEditingLocked }"
                                :value="item.id"
                                v-model="selectedItems"/>
                    </td>
                    <td style="padding: 2px">
                      <!--                    <div class="p-d-flex p-ai-center">-->
                      <Button @click.stop="toggleFlagged(item)"
                              class="p-button-text"
                              v-tooltip.top="item.is_flagged ? $t('unflagMessageTooltip') : $t('flagMessageTooltip')"
                              :icon="item.is_flagged ? 'pi pi-star-fill' : 'pi pi-star'"
                              :class="{'highlight--link':isItemSelected(item.id)}"/>
                    </td>
                    <td @click="emailOnClick(item)" class="word-break message-clickable-cell">
                      <span v-if="item.from_name">{{ item.from_name }}</span>
                      <span v-else-if="item.from_email">{{ item.from_email }}</span>
                      <i v-else class="ti-minus"></i>
                    </td>
                    <td class="message-clickable-cell p-p-1" @click="emailOnClick(item)">
                      <Button v-if="!item.is_seen"
                              @click.stop="toggleMessageIsSeen(item)"
                              class="p-button-text warning-color"
                              v-tooltip.top="$t('markAsSeenTooltip')"
                              icon="pi pi-exclamation-circle"
                              :class="{'highlight--link':isItemSelected(item.id)}">
                      </Button>
                    </td>
                    <td @click="emailOnClick(item)" class="mail-text-cell message-clickable-cell" style="min-width: 300px">
                      <div class="mail-cell" v-if="item.subject || item.title" style="min-width: 300px">
                        <div class="mail-cell__text">
                          <span v-show="item.subject">{{ item.subject }}</span>
                          <span v-show="item.subject && item.title"> - </span>
                          <span v-if="item.title"
                                style="font-size: 0.9em;">
<!--                                :style="{'font-weight' : !item.subject && !item.is_seen ? 500 : 300}">-->
                          {{ item.title }}
                        </span>
                        </div>
                      </div>

                      <i v-else class="ti-minus"></i>
                    </td>

                    <td @click="emailOnClick(item)" class="message-clickable-cell">
                      <div>
                        <div v-if="item.answers?.length" class="p-d-flex p-ai-center" style="font-size: 0.9em; font-weight: 400;padding: 4px;">
                          <i class="ti-comment-alt" style="margin-right: 3px;"/>
                          <div>{{ item.answers.length }}</div>
                        </div>
                        <div v-if="item.attachments?.length" class="p-d-flex p-ai-center" style="font-size: 0.9em; font-weight: normal;padding: 4px;">
                          <i class="ti-clip" style="margin-right: 3px;"/>
                          <div>{{ item.attachments.length }}</div>
                        </div>
                      </div>
                    </td>
                    <td @click="emailOnClick(item)" class="message-clickable-cell">
                      <span v-if="item.created_at">{{ formatDate(item.created_at) }}</span>
                    </td>
                  </tr>
                </template>
              </DesktopDataTable>

              <DesktopDataTable v-else
                                :dataTableIsLoading="dataTableIsLoading"
                                :isFixedLayout="true"
                                tableClass="test"
                                :showHeader="false"
                                :tableName="$t('Emails')"
                                :itemsArrayIsEmpty="itemsArrayIsEmpty"
                                :showButtons="false"
                                :showSearchInput="false"
                                :headers="[
                                {name: '', title: '', width: '26px', sortable: false},
                                {name: 'data', sortable: false},
                                {name: 'icons', width: '40px', sortable: false},
                              ]">
                <template v-slot:multiselectHeader>
                  <th v-show="$store.getters.isAccountantOrHigher" class="multiSelect-column-header">
                    <Checkbox :disabled="dataTableIsLoading || billingDataEditingLocked"
                              :class="{ 'billing-selection-checkbox-disabled': billingDataEditingLocked }"
                              @click="selectAllCheckboxOnClick"
                              :value="0"
                              v-model="selectAllCheckbox"/>
                  </th>
                </template>
                <template v-slot:body>
                  <tr v-for="(item, index) of items"
                      :key="index"
                      class="messages-row"
                      :class="[{'p-highlight': isItemSelected(item.id)}, {'bold-text' : !item.is_seen}]">
                    <td v-show="$store.getters.isAccountantOrHigher"
                        :class="{
                          'new-item': isItemAdded(item.id),
                          'billing-selection-cell-disabled': billingDataEditingLocked
                        }">
                      <Checkbox @click.stop
                                v-if="!isItemAdded(item.id)"
                                :disabled="dataTableIsLoading || billingDataEditingLocked"
                                :class="{ 'billing-selection-checkbox-disabled': billingDataEditingLocked }"
                                :value="item.id"
                                v-model="selectedItems"/>
                    </td>
                    <td style="padding: 2px">
                      <div class="p-d-flex p-ai-center">
                        <Button @click.stop="toggleFlagged(item)"
                                class="p-button-text"
                                v-tooltip.top="item.is_flagged ? $t('unflagMessageTooltip') : $t('flagMessageTooltip')"
                                :icon="item.is_flagged ? 'pi pi-star-fill' : 'pi pi-star'"
                                :class="{'highlight--link':isItemSelected(item.id)}"/>
                      </div>
                    </td>
                    <td @click="emailOnClick(item)" class="word-break message-clickable-cell">
                      <div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                        <span v-if="item.from_name">{{ item.from_name }}</span>
                        <span v-else-if="item.from_email">{{ item.from_email }}</span>
                        <i v-else class="ti-minus"></i>
                      </div>

                      <div class="mail-cell p-mt-1" v-if="item.subject || item.title">
                        <div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                          <span v-show="item.subject">{{ item.subject }}</span>
                          <span v-show="item.subject && item.title"> - </span>
                          <span v-if="item.title"
                                style="font-size: 0.9em;">
                          {{ item.title }}
                        </span>
                        </div>
                      </div>

                      <div v-if="item.created_at" class="p-mt-1">{{ formatDate(item.created_at) }}</div>
                    </td>

                    <td @click="emailOnClick(item)" class="message-icons-cell message-clickable-cell">
                      <div class="message-icons">
                        <Button v-if="!item.is_seen"
                                @click.stop="toggleMessageIsSeen(item)"
                                class="p-button-text message-icon-button warning-color"
                                v-tooltip.top="$t('markAsSeenTooltip')"
                                icon="pi pi-exclamation-circle"
                                :class="{'highlight--link': isItemSelected(item.id)}"/>

                        <div v-if="item.answers?.length" class="message-icon-count">
                          <i class="ti-comment-alt"></i>
                          <span>{{ item.answers.length }}</span>
                        </div>

                        <div v-if="item.attachments?.length" class="message-icon-count">
                          <i class="ti-clip"></i>
                          <span>{{ item.attachments.length }}</span>
                        </div>
                      </div>
                    </td>

                  </tr>
                </template>
              </DesktopDataTable>
            </template>


            <div v-else-if="!isLoading && messageIsOpened">
              <div class="p-d-flex p-jc-between p-ai-center p-flex-wrap">
                <div style="line-height: 1.5;">
                  <div v-show="openedMessage.subject" class="text-wrap">
                    <span class="opened-message-title">{{ $t('Subject') }}: </span>{{ openedMessage.subject }}
                    <!--                     <span style="font-weight: 500; font-size: 1.1em">-->
                    <!--                       {{ openedMessage.subject }}-->
                    <!--                     </span>-->
                  </div>
                  <div class="text-wrap">
                    <span class="opened-message-title">{{ $t('From') }}:</span> {{ openedMessage.from_name }} {{ openedMessage.from_email }}
                  </div>
                  <div class="text-wrap">
                    <span class="opened-message-title">{{ $t('To') }}:</span> {{ openedMessage.to_name }} {{ openedMessage.to_email }}
                  </div>
                  <div class="text-wrap">
                    <span class="opened-message-title">{{$t('Created')}}:</span> {{ formatBy(openedMessage.created_at, openedMessage.createdBy) }}
                  </div>
                  <div v-if="openedMessage.answers?.length" class="text-wrap">
                    <span class="opened-message-title">{{ $t('answersLabel') }}: </span>
                    <span v-for="(answer, index) of openedMessage.answers" :key="answer.id">
                        <a @click.prevent="emailAnswerOnClick(answer)" class="p-link">
                          {{ formatBy(answer.created_at, answer.createdBy) }}
                        </a>
                        <span v-if="openedMessage.answers.length > 1 && index !== openedMessage.answers.length - 1"> | </span>
                     </span>
                  </div>
                  <div v-if="openedMessage.is_seen_at || openedMessage.seenBy" class="text-wrap">
                    <span class="opened-message-title">{{ $t('seenAtLabel') }}:</span> {{ formatBy(openedMessage.is_seen_at, openedMessage.seenBy) }}
                  </div>
                </div>
                <EmailAttachmentButton :message="openedMessage"/>
                <ul class="p-mr-3 p-d-flex p-ai-center p-flex-wrap">
                  <li>
                    <span class="p-d-inline-flex"
                          v-tooltip.top="billingActionTooltipOptions()">
                      <Button :label="$t('Reply')"
                              icon="pi pi-reply"
                              class="p-button-text p-mr-1"
                              :disabled="billingDataEditingLocked"
                              @click="replyMessage(openedMessage)"/>
                    </span>
                  </li>
                  <li>
                    <span class="p-d-inline-flex"
                          v-tooltip.top="billingActionTooltipOptions()">
                      <Button :label="$t('Forward')"
                              class="p-button-text p-mr-1"
                              :disabled="billingDataEditingLocked"
                              @click="forwardMessage(openedMessage)"/>
                    </span>
                  </li>
                  <li>
                    <Button class="p-button-text"
                            v-tooltip.top="openedMessage.is_seen ? $t('markAsUnseenTooltip') : $t('markAsSeenTooltip')"
                            @click.stop="toggleMessageIsSeen(openedMessage)"
                            :icon="openedMessage.is_seen ? 'pi pi-envelope' : 'pi pi-exclamation-circle'"
                            :class="{ 'warning-color': !openedMessage.is_seen }"/>
                  </li>
                  <li>
                    <Button class="p-button-text"
                            v-tooltip.top="openedMessage.is_flagged ? $t('unflagMessageTooltip') : $t('flagMessageTooltip')"
                            @click.stop="toggleFlagged(openedMessage)"
                            :icon="openedMessage.is_flagged ? 'pi pi-star-fill' : 'pi pi-star'"/>
                  </li>
                  <li v-show="$store.getters.isAccountantOrHigher">
                    <span class="p-d-inline-flex"
                          v-tooltip.top="billingActionTooltipOptions(false, $t('Delete'))">
                      <Button icon="ti-trash"
                              :disabled="dataTableIsLoading || billingDataEditingLocked"
                              class="p-button-text p-button-danger p-mr-1"
                              @click="confirmItemDelete({ id: openedMessage.id })"/>
                    </span>
                  </li>
                  <li>
                    <Button icon="ti-close"
                            v-tooltip.top="$t('Close')"
                            class="p-button-text"
                            @click="closeMessage"/>
                  </li>
                </ul>
              </div>

              <hr>

              <div id="iframe-container" class="iframe-container">
                <iframe id="message-frame"
                        @load="calculateIframeHeight"
                        loading="lazy"
                        allow="fullscreen"
                        seamless
                        :srcdoc="computedSrcDoc">
                </iframe>
              </div>
            </div>
          </div>
        </div>

        <OwnPaginator v-show="!itemsArrayIsEmpty && !messageIsOpened"
                      :rows="pagination.perPage"
                      :currentPage="pagination.currentPage - 1"
                      :totalPages="pagination.pageCount"
                      :totalRecords="pagination.totalCount"
                      :rowsPerPageOptions="[5,10,25,50,100,200]"
                      :pageLinkSize="11"/>

        <TotalRecordsData v-show="!messageIsOpened" :pagination="pagination" :itemsArrayIsEmpty="itemsArrayIsEmpty"/>

        <EmailModal :visible="itemModal"
                    :selectedEmailId="selectedEmailId"
                    @close="closeItemModal"
                    @update-message="updateMessage"
                    :item="item"/>

        <ConfirmDeleteModal :visible="confirmItemDeleteModal"
                            :modalDataIsLoading="dataIsSending"
                            @close="closeConfirmItemDeleteModal"
                            @delete-item="deleteItem"/>

        <ConfirmMultipleDeleteModal :showSpinner="dataIsSending"
                                    :visible="confirmItemsMultipleDeleteModal"
                                    @close="closeConfirmItemsMultipleDeleteModal"
                                    @delete-items="deleteMultipleItems"/>

        <EmailAnswerModal :visible="emailAnswerModal"
                          :item="emailAnswer"
                          @close="closeEmailAnswerModal"/>

      </div>
    </div>
  </div>
</template>

<script>
import EmailModal from "@/pages/messages/components/EmailModal";
import httpClient from "@/services/http.services";
import datatableMixins from "@/mixins/datatableMixins";
import formatMixins from "@/mixins/formatMixins";
import OwnTree from "@/components/OwnTree/OwnTree";
import settings from "@/settings";
import EmailAttachmentButton from "@/pages/messages/components/EmailAttachmentButton";
import httpMixins from "@/mixins/httpMixins";
import ConfirmMultipleDeleteModal from "@/components/ConfirmMultipleDeleteModal";
import EmailAnswerModal from "@/pages/messages/components/EmailAnswerModal";
import showErrorsMixins from "@/mixins/showErrorsMixins";
import authService from "@/services/auth.service";
import billingRestrictionsMixin from '@/mixins/billingRestrictionsMixin'

const GET_MESSAGES_TIME = 120 * 1000; //2min (120sec * 1000)

export default {
  mixins: [ datatableMixins, formatMixins, httpMixins, showErrorsMixins, billingRestrictionsMixin ],
  components: { EmailModal, OwnTree, EmailAttachmentButton, ConfirmMultipleDeleteModal, EmailAnswerModal },
  name: 'Messages',
  data() {
    return {
      dataIsSending: false,
      userEmailAccountsLoaded: false,
      emailAnswer: {},
      emailAnswerModal: false,
      srcdoc: null,
      messageIsOpened: false,
      openedMessage: {},
      // isLoading: true,
      receivedMessage: '',
      messagesState: '1',
      selectedFolder: null,
      selectedEmailId: null,
      // categories: [],
      emailsList: [],
      emailAccounts: [],
      // emailsTrees: [],
      expandedKeys: {},
      fieldsExpand: 'attachments,answers',
      apiLink: 'mail/get-messages',
      routePath: '/messages',
      refreshButtonIsClicked: false,
      getMessagesInterval: null,
      getMessagesIntervalInFlight: false,
      emailAccountsFetchInFlight: false,
      newUnansweredEmailsCount: null
    }
  },
  watch: {
    messagesState() {
      this.closeMessage()
      this.pagination.currentPage = 1
      this.getItems()
    },
    '$i18n.locale'() {
      this.generateEmailsTree()
    },
    '$store.state.firstLayerIsOpened'() {
      if (!this.$store.state.firstLayerIsOpened) {
        if (this.emailAnswerModal) {
          this.closeEmailAnswerModal()
        }
      }
    },
    selectedItems() {
      this.checkAllItemsAreSelected()
    }
  },
  mounted() {
    this.scrollToTop()
    if (settings.autoLogoutTimeout && this.$store.state.logoutTimestampIsOverdue) return false
    this.checkRouteQuery()
    this.getPageData()
  },
  unmounted() {
    this.clearGetMessagesInterval()
  },
  methods: {
    patchItemInList(patch) {
      if (!Array.isArray(this.items) || !patch?.id) return
      const idx = this.items.findIndex(i => i.id === patch.id)
      if (idx < 0) return
      this.items[idx] = { ...this.items[idx], ...patch }
    },

    async loadAccounts({ showSpinner = false } = {}) {
      if (!this.userCanGetData || this.emailAccountsFetchInFlight) return false
      this.isLoading = showSpinner
      const res = await this.getShowableUserEmailAccounts()
      if (!res?.success || !res.accounts?.length) {
        this.emailAccounts = []
        this.emailsList = []
        this.items = []
        this.messageIsOpened = false
        this.openedMessage = {}
        return false
      }

      this.emailAccounts = this.generateEmailAccounts(res.accounts)

      const unanswered = this.emailAccounts.reduce((sum, a) => sum + Number(a.unansweredCount || 0), 0)
      this.$store.commit('updateUnansweredEmailsCount', unanswered)

      this.generateEmailsTree()
      return true
    },

    async loadMessages({ showSpinner = false, showToast = false } = {}) {
      return this.getItems(showSpinner, showToast)
    },

    async initPage({ showSpinner = true } = {}) {
      this.messageIsOpened = false
      this.openedMessage = {}
      const ok = await this.loadAccounts({ showSpinner })
      if (!ok) return
      this.selectFirstNode()
      await this.loadMessages({ showSpinner })
    },

    async refreshAll({ keepSelection = true } = {}) {
      const ok = await this.loadAccounts({ showSpinner: false })
      if (!ok) return
      if (!keepSelection) this.selectFirstNode()
      // если selection уже есть — просто обнови список
      await this.loadMessages({ showSpinner: false })
    },

    async refreshMessages() {
      await this.loadMessages({ showSpinner: false })
    },

    // updateEmailCellsMode() {
    //   this.$nextTick(() => {
    //     const cells = this.$el.querySelectorAll('td.email-cell')
    //     cells.forEach(td => {
    //       const width = td.clientWidth
    //       if (width >= 300) {
    //         td.classList.add('email-cell--wide')
    //       } else {
    //         td.classList.remove('email-cell--wide')
    //       }
    //     })
    //   })
    // },
    getPageData() {
      if (!this.userCanGetData) return
      this.initPage({ showSpinner: true })
      this.setGetMessagesInterval()
    },
    async setGetMessagesInterval() {
      if (this.getMessagesInterval) return
      this.getMessagesInterval = setInterval(async () => {
        const token = authService.getToken?.();
        if (!token) return;

        const lastUnansweredEmailsCount = this.$store.state.unansweredEmailsCount ?? 0;
        let unansweredEmailsCount = 0

        if (this.getMessagesIntervalInFlight) return;
        this.getMessagesIntervalInFlight = true;

        try {
          const res = await this.getShowableUserEmailAccounts();
          if (!res?.success) return
          const accounts = this.generateEmailAccounts(res.accounts)

          this.emailAccounts = accounts
          accounts?.forEach(acc => {
            const c = Number(acc.unansweredCount || 0);
            unansweredEmailsCount += c;
          });


          if (unansweredEmailsCount !== lastUnansweredEmailsCount && !this.messageIsOpened) {
            this.generateEmailsTree()
            this.getItems(false)
          } else if (unansweredEmailsCount !== lastUnansweredEmailsCount) {
            this.generateEmailsTree()
          }
        } finally {
          this.getMessagesIntervalInFlight = false;
          this.$store.commit('updateUnansweredEmailsCount', unansweredEmailsCount)
        }
      }, GET_MESSAGES_TIME)
    },
    clearGetMessagesInterval() {
      if (!this.getMessagesInterval) return false;
      clearInterval(this.getMessagesInterval);
      this.getMessagesInterval = null
      return true;
    },

    generateEmailAccounts(accounts) {
      if (!accounts) return []
      return accounts.map(acc => {
        return {
          id: +acc.id,
          username: acc.username,
          // sender_name: acc.sender_name,
          starredCount: +acc.starredCount,
          unansweredCount: +acc.unansweredCount,
        }
      })
    },

    async getShowableUserEmailAccounts() {
      if (!this.userCanGetData || this.emailAccountsFetchInFlight) return
      this.emailAccountsFetchInFlight = true
      try {
        // console.log('fetch getShowableUserEmailAccounts')
        const { status, data } = await httpClient('email-account/get-showable-user-email-accounts?expand=unansweredCount,starredCount');
        if (status === 200 && data) {
          return { success: true, accounts: data };
        } else {
          return { success: false, accounts: [] };
        }
      } catch (err) {
        this.showError(err);
        return { success: false, error: err };
      } finally {
        this.emailAccountsFetchInFlight = false
        this.isLoading = false;
      }
    },
    emailAnswerOnClick(answer) {
      this.emailAnswer = { ...answer }
      this.emailAnswerModal = true
      this.$store.commit('toggleFirstLayer', true)
    },
    closeEmailAnswerModal() {
      this.emailAnswer = {}
      this.emailAnswerModal = false
      this.$store.commit('toggleFirstLayer', false)
    },
    // calculateIframeHeight() {
    //   const messageFrame = document.getElementById('message-frame')
    //
    //   const scrollHeight = messageFrame.contentWindow.document.body.scrollHeight
    //   if (messageFrame) {
    //     if (messageFrame.contentWindow.document.body.scrollHeight > 0) {
    //       messageFrame.style.height = scrollHeight + 65 + 'px'
    //     }
    //   }
    // },
    calculateIframeHeight() {
      const messageFrame = document.getElementById('message-frame')
      if (!messageFrame?.contentWindow?.document?.body) return

      const scrollHeight = messageFrame.contentWindow.document.body.scrollHeight

      if (scrollHeight > 0) {
        messageFrame.style.height = scrollHeight + 65 + 'px'
      }
    },
    replyMessage(message) {
      if (this.billingActionIsRestricted()) return

      this.item = {
        ...message,
        id: +message.id,
        reply: true,
        forward: false,
        to_email: message.from_email
      }
      this.itemModal = true
      this.$store.commit('toggleFirstLayer', true)
    },
    forwardMessage(message) {
      if (this.billingActionIsRestricted()) return

      this.item = {
        ...message,
        id: +message.id,
        reply: false,
        forward: true,
      }
      this.itemModal = true
      this.$store.commit('toggleFirstLayer', true)
    },
    async deleteItem() {
      if (this.billingActionIsRestricted()) return

      const messageId = this.itemToDelete?.id

      if (!messageId) {
        return false
      }

      this.dataIsSending = true

      try {
        const { status, data } = await httpClient.post('mail/delete-message', { id: messageId })
        if (status === 200 && data?.success) {
          this.$toast.add({severity:'success', detail: this.$t('Data deleted'), life: settings.toastLife});
          this.closeConfirmItemDeleteModal()
          await this.refreshAll({ keepSelection: true })
          this.closeMessage()
        } else {
          this.showUnknownError()
        }
      } catch(err) {
        this.showError(err)
      } finally {
        this.dataIsSending = false
      }
    },
    async deleteMultipleItems() {
      if (this.billingActionIsRestricted()) return

      if (!this.selectedItems?.length) return
      this.dataIsSending = true
      try {
        const { status, data } = await httpClient.post('mail/delete-multiple-messages', { ids: this.selectedItems })
        if (status === 200 && data?.success) {
          this.$toast.add({severity:'success', detail: this.$t('Data deleted'), life: settings.toastLife});

          await this.refreshAll({ keepSelection: true })
          this.closeConfirmItemsMultipleDeleteModal()

          this.selectedItems = []
          this.selectAllCheckbox = []

          this.closeMessage()
        } else {
          this.showUnknownError()
        }
      } catch(err) {
        this.showError(err)
      } finally {
        this.dataIsSending = false
      }
    },
    async updateMessage(message) {
      if (!message) return

      // Если мы сейчас в Sent того же аккаунта — обновить список
      if (this.selectedFolderNum === 2 && this.selectedEmailId === message.email_account_id) {
        await this.refreshMessages()
      }

      if (message.is_reply) {
        if (this.messageIsOpened && this.openedMessage) {
          this.openedMessage.is_seen = 1
        }

        await this.refreshAll({ keepSelection: true })

        const answer = {
          html_text: message.html_text,
          plain_text: message.plainText,
          createdBy: {
            first_name: this.$store.state.user?.first_name,
            last_name: this.$store.state.user?.last_name,
          },
          created_at: Date.now() / 1000
        }

        if (this.openedMessage?.answers) {
          this.openedMessage.answers.push(answer)
        }
      }
    },
    async changeEmailAccount(node) {
      if (!node) return
      if (this.messageIsOpened) this.closeMessage()
      if (node.folder === this.selectedFolderNum && node.emailAccountId === this.selectedEmailId) return

      this.clearLastSearching()

      this.selectedItems = []
      this.selectAllCheckbox = []

      this.selectedEmailId = node.emailAccountId
      this.selectedFolderNum = node.folder

      this.resetRouteAndPagination()

      await this.loadMessages({ showSpinner: true })
    },
    selectFirstNode() {
      if (!this.emailsListIsEmpty && !this.$route.query.emailAccountId && !this.$route.query.folder) {
        const key = this.emailsList[0]?.children?.[0].key
        const splittedKey = key?.split('-')
        this.selectedEmailId = +splittedKey?.[0]
        this.selectedFolderNum = +splittedKey?.[1]

        let obj = {}
        obj[key] = true
        this.selectedFolder = obj

        this.resetRouteAndPagination()
      }
    },
    emailOnClick(item) {
      if (!item) return false
      this.getEmailData(item)
    },
    async getEmailData(item) {
      if (!item.id) return
      this.isLoading = true
      try {
        const { status, data } = await httpClient.post('mail/get-message-data?expand=attachments,html_text,plain_text,answers,answers.plain_text,answers.html_text,answers.createdBy,createdBy,seenBy', { id: item.id })
        if (status === 200 && data?.success && data.email) {
          this.messageIsOpened = true
          this.openedMessage = data.email
        } else if (data?.error) {
          if (settings.isDevMode) console.log(data.error)
          this.$toast.add({severity:'error', summary: data.error.summary, detail: data.error.detail, life: this.settings.toastLife})
        } else {
          this.showUnknownError()
        }
      } catch(err) {
        this.showError(err)
      } finally {
        this.isLoading = false
      }
    },
    async toggleMessageIsSeen(message) {
      if (!message) return

      const id = message.id
      const next = !message.is_seen
      const prev = message.is_seen

      message.is_seen = next

      this.patchItemInList({ id, is_seen: next })

      try {
        const { status, data } = await httpClient.post('mail/toggle-seen', { id, state: next })
        if (status === 200 && data?.success) {
          const meta = next
              ? {
                is_seen_at: Date.now() / 1000,
                seenBy: {
                  first_name: this.$store.state.user?.first_name,
                  last_name: this.$store.state.user?.last_name,
                },
              }
              : { is_seen_at: null, seenBy: null }

          Object.assign(message, meta)
          this.patchItemInList({ id, ...meta })

          // счетчики/дерево (unanswered) — ок подтянуть
          await this.loadAccounts({ showSpinner: false })
        } else {
          // rollback
          message.is_seen = prev
          this.patchItemInList({ id, is_seen: prev })
          this.showUnknownError()
        }
      } catch (err) {
        message.is_seen = prev
        this.patchItemInList({ id, is_seen: prev })
        this.showError(err)
      }
    },
    async toggleFlagged(item) {
      if (!item) return

      const id = item.id
      const prev = item.is_flagged
      const next = !prev

      item.is_flagged = next
      this.patchItemInList({ id, is_flagged: next })

      try {
        const { status, data } = await httpClient.post('mail/toggle-flagged', { id, state: next })
        if (status === 200 && data?.success) {
          // если мы в Starred и сняли флаг — убрать строку
          if (this.selectedFolderNum === 4 && !next) {
            this.items = this.items?.filter(i => i.id !== id)
          }

          // обновить дерево (starredCount)
          await this.loadAccounts({ showSpinner: false })
        } else {
          item.is_flagged = prev
          this.patchItemInList({ id, is_flagged: prev })
          this.showUnknownError()
        }
      } catch (err) {
        item.is_flagged = prev
        this.patchItemInList({ id, is_flagged: prev })
        this.showError(err)
      }
    },
    closeMessage() {
      this.messageIsOpened = false
      this.openedMessage = {}
      this.item = {}
    },
    generateEmailsTree() {
      const accountsCategoryList = []
      this.emailAccounts?.forEach(acc => {
        // if (!account.accountData) return;
        const emailId = acc.id
        accountsCategoryList.push({
          key: emailId, label: acc.username, style: 'text-transform: lowercase', styleClass: 'tree-node tree-node--bold', selectable: false, children: [
            {key: emailId + '-1', label: this.$t('Inbox'), emailAccountId: emailId, folder: 1, unansweredMessages: acc.unansweredCount, icon: 'ti-import'},
            {key: emailId + '-2', label: this.$t('Sent'), emailAccountId: emailId, folder: 2,icon: 'ti-export'},
            // {key: emailId + '-3', label: 'Spam', emailAccountId: emailId, folder: 3,icon: 'ti-na'},
            {key: emailId + '-4', label: this.$t('Starred'), emailAccountId: emailId, folder: 4, starredMessages: acc.starredCount, icon: 'ti-star'},
          ]
        })
        this.expandedKeys[emailId] = true
      })
      this.emailsList = accountsCategoryList
    },
    async getItems(showSpinner = false, showToast = false) {
      if (this.emailsListIsEmpty) return
      if (!this.userCanGetData || this.fetchInFlight) return
      // console.log('fetch get items')

      this.dataTableIsLoading = true
      this.isLoading = showSpinner
      const ctrl = this.setController?.('messages')
      try {
        const { status, data, headers } = await httpClient({
          url: this.apiLink,
          params: {
            folder: this.selectedFolderNum,
            emailAccountId: this.selectedEmailId,
            messagesState: this.messagesState,
            page: this.pagination.currentPage,
            'per-page': this.pagination.perPage,
            sort: this.sort.direction + this.sort.column,
            search: this.processedSearchValue ?? null,
            expand: this.fieldsExpand
          },
          signal: ctrl?.signal
        })

        if (status === 200 && data && Array.isArray(data)) {
          const hasPaginationHeaders = !!headers['x-pagination-total-count']
          if (hasPaginationHeaders) {
            this.pagination.totalCount = +headers['x-pagination-total-count']
            this.pagination.pageCount  = +headers['x-pagination-page-count']
          } else {
            this.pagination.totalCount = data.length
            this.pagination.pageCount  = 1
          }

          this.items = data

          if (!data.length) {
            this.pagination.pageCount = 1
            this.pagination.currentPage = 1
          }

          if (showToast) {
            this.$toast.add({severity: 'success', detail: this.$t('messagesReceivedMsg'), life: settings.toastLife});
          }
        } else {
          this.items = []
          this.showUnknownError()
        }
      } catch(err) {
        this.showError(err)
      } finally {
        this.$store.commit('SET_FETCH_IN_FLIGHT', false)
        this.refreshButtonIsClicked = false
        this.isLoading = false
        // console.log('messages received')
        this.dataTableIsLoading = false
        this.checkAllItemsAreSelected()
        if (this._abortors?.messages === ctrl) {
          this._abortors.messages = null
        }
      }
    },
    createMessage() {
      if (this.billingActionIsRestricted()) return

      this.item = {
        reply: false,
        forward: false,
      }

      this.itemModal = true
      this.$store.commit('toggleFirstLayer', true)
    },
    escapeHtml(value) {
      return String(value || '')
          .replaceAll('&', '&amp;')
          .replaceAll('<', '&lt;')
          .replaceAll('>', '&gt;')
          .replaceAll('"', '&quot;')
          .replaceAll("'", '&#039;')
    },

    sanitizeEmailHtml(html) {
      return String(html || '')
          .replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, '')
          .replace(/\son\w+="[^"]*"/gi, '')
          .replace(/\son\w+='[^']*'/gi, '')
          .replace(/<img[^>]+src=["']https?:\/\/[^"']+["'][^>]*>/gi, '')
    },
  },
  computed: {
    emailsListIsEmpty() {
      return !this.emailsList?.length
    },
    computedSrcDoc() {
      if (!this.openedMessage || !Object.keys(this.openedMessage).length) return ''

      const textColorDiv = this.$store.getters.actualSchema === 'light'
          ? '<div style="color: #495057">'
          : '<div style="color: #FFFFFFDE">'


      if (this.openedMessage.html_text) {
        return `<base target="_blank">${textColorDiv}${this.sanitizeEmailHtml(this.openedMessage.html_text)}</div>`
      }

      if (this.openedMessage.plain_text) {
        return `<base target="_blank">${textColorDiv}<div style="white-space: pre-wrap">${this.escapeHtml(this.openedMessage.plain_text)}</div></div>`
      }

      return ''
    }
  }
}
</script>

<style scoped lang="scss">
.radiobuttons-wrapper {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
}

//.p-field-radiobutton {
//margin-bottom: 0;
//margin-left: 15px;
//gap: 10px;
//flex-wrap: wrap;
//}

//.radio_button {
/*background-color: red;*/
/*padding: 5px;*/
//}
.radio_button_label {
  margin-left: 5px;
  padding: 7px 7px 7px 0;
  cursor: pointer;
}

//.messages-row {
//  td {
//    height: 50px;
//  }
//  &:hover {
//    cursor: pointer;
//    //box-shadow: 10px 10px 10px red;
//  }
//}

.messages-row td {
  height: 50px;
}

.message-clickable-cell {
  cursor: pointer;
}

.email-flag-btn {
  font-size: 1.1em;
  border-radius: 5px;
  padding: 10px;
  &:hover {
    opacity: 0.7;
  }
}

.bold-text {
  font-weight: 500;
}

.iframe-container iframe {
  border: 0;
  padding: 0;
  //position: absolute;
  //top: 0;
  //left: 0;
  width: 100%;
  height: 350px;
}

ul {
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  li {
    margin: 0 3px;
  }
}


.no-data-block {
  padding: 10vh 0;
  //height: 100%;
  text-align: center;
}


.mail-text-cell {
  overflow: hidden;
  min-width: 280px;   /* выбери своё значение, напр. 250–300 */
}

.mail-cell {
  display: flex;
  align-items: center;
  max-width: 100%;
  overflow: hidden;
}

.mail-cell__text {
  flex: 1 1 auto;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;  /* "..." */
}

.mail-cell__meta {
  flex: 0 0 auto;
  margin-left: 8px;
  white-space: nowrap;
}

.opened-message-title {
  font-weight: 500;
}

.message-icons-cell {
  width: 42px;
  vertical-align: top;
  text-align: center;
}

.message-icons {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.message-icon-button {
  width: 24px !important;
  height: 24px !important;
  padding: 0 !important;
}

.message-icon-count {
  min-width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  font-size: 0.9em;
  font-weight: 400;
}

.messages-row:hover td.billing-selection-cell-disabled {
  cursor: not-allowed !important;
}

:deep(.billing-selection-checkbox-disabled),
:deep(.billing-selection-checkbox-disabled .p-checkbox-box),
:deep(.billing-selection-checkbox-disabled input) {
  cursor: not-allowed !important;
}
</style>